import { CUSTOMER_GRID_STATE_CHANGE } from "../constants";

export const changeCustomerGridState = gridState => dispatch =>
    dispatch({
        type: CUSTOMER_GRID_STATE_CHANGE,
        payload: gridState,
    });
